export const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://sentechonline.com/api/api';
export const BACKEND_BASE_URL = process.env.REACT_APP_BACKEND_URL || 'https://sentechonline.com/api';

export const ROUTES = {
  LOGIN: '/login',
  DASHBOARD: '/dashboard',
  CUSTOMERS: '/customers',
  INVOICES: '/invoices',
  EMPLOYEES: '/employees',
  RECEIVED_AMOUNT: '/received-amount',
  SETTINGS: '/settings',
} as const;

export const INVOICE_STATUS = {
  PENDING: 'pending',
  PAID: 'paid',
  PARTIALLY_PAID: 'partially_paid',
  OVERDUE: 'overdue',
} as const;

export const PAYMENT_METHODS = {
  CASH: 'cash',
  BANK_TRANSFER: 'bank_transfer',
  CARD: 'card',
  CHECK: 'check',
  OTHER: 'other',
} as const;

export const USER_ROLES = {
  ADMIN: 'admin',
  EMPLOYEE: 'employee',
} as const;

export const TABLE_PAGE_SIZES = [10, 25, 50, 100];

export const DATE_FORMAT = 'YYYY-MM-DD';
export const DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';

export const CHART_COLORS = {
  PRIMARY: '#3B82F6',
  SUCCESS: '#10B981',
  WARNING: '#F59E0B',
  DANGER: '#EF4444',
  INFO: '#06B6D4',
  SECONDARY: '#6B7280',
};

export const VALIDATION_MESSAGES = {
  REQUIRED: 'This field is required',
  EMAIL: 'Please enter a valid email address',
  MIN_LENGTH: (min: number) => `Minimum length is ${min} characters`,
  MAX_LENGTH: (max: number) => `Maximum length is ${max} characters`,
  PASSWORD_MATCH: 'Passwords do not match',
  INVALID_NUMBER: 'Please enter a valid number',
  POSITIVE_NUMBER: 'Please enter a positive number',
}; 
